<template>
  <component :is="indexPageComponent" />
</template>

<router>
{
  name: 'indexPage'
}
</router>

<script>
import { computed, useContext } from "@nuxtjs/composition-api";
import PriceOfferIndexPage from "~/components/_refactored/indexPage/PriceOfferIndexPage.vue";
import DefaultIndexPage from "~/components/_refactored/indexPage/DefaultIndexPage.vue";
import ModularIndexPage from "~/components/_refactored/indexPage/ModularIndexPage.vue";
import { useUserStore } from "~/stores/user";

const IS_MODULAR_ENABLED =
  process.env.ENABLE_MODULAR_FRONT_PAGE === "true";

const MODULAR_USER_IDS = [1188288, 32480, 235006, 571754];

function isModularUser(pinia) {
  const userStore = useUserStore(pinia);
  const userId = parseInt(userStore.me?.id);
  return MODULAR_USER_IDS.includes(userId);
}

export default {
  name: "IndexPage",
  layout(context) {
    if (IS_MODULAR_ENABLED) return "ModularFrontPageLayout";
    if (isModularUser(context.$pinia)) return "ModularFrontPageLayout";
    return "DefaultLayout";
  },
  setup() {
    const { $branding, $pinia } = useContext();

    const indexPageComponent = computed(() => {
      if (IS_MODULAR_ENABLED || isModularUser($pinia)) {
        return ModularIndexPage;
      } else if ($branding.isPriceOffer) {
        return PriceOfferIndexPage;
      } else {
        return DefaultIndexPage;
      }
    });

    return {
      indexPageComponent,
    };
  },
};
</script>
